// Désactive le menu contextuel sur tous les liens
export const disableContextMenu = () => {
  // Empêcher le menu contextuel sur les liens
  document.addEventListener('contextmenu', (e) => {
    const target = e.target as HTMLElement;
    // Vérifier si c'est un lien ou à l'intérieur d'un lien
    if (target.tagName === 'A' || target.closest('a')) {
      e.preventDefault();
      return false;
    }
  });
};
